import { Icon } from '@iconify/react';
import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

// this helper converts the answer from the survey instance to an array of selected question choices
// for checkbox: [true, false, true, false] is converted to [Option 1, Option 3]
// for radio: 0 is converted to [Option 1]
function selectedAnswersArray(chartQuestion, patientEntry) {
  switch (chartQuestion.type) {
    case 'checkbox':
      if (_.isArray(patientEntry)) {
        const selectedList = _.filter(
          chartQuestion.answers,
          (_checkbox, i) => patientEntry[i]
        );
        return _.map(selectedList, 'chartLabel');
      }
      break;

    case 'radio':
      {
        const index = _.toNumber(patientEntry);
        if (_.isNumber(index)) {
          return [chartQuestion.answers[index].chartLabel];
        }
      }
      break;

    default:
      return [];
  }
}

export function Table({ question, entries }) {
  const { t } = useTranslation('progress');

  const checkboxValue = (questionItem, entryIndex) => {
    const entryForDay = entries[entryIndex];

    if (entryForDay.skipped) {
      return (
        <Icon
          aria-label={t('common.text.no_entry')}
          className="text-default-500"
          icon="mdi:dot"
        />
      );
    }

    const selectedItems = selectedAnswersArray(question, entryForDay.answer);

    if (selectedItems.includes(questionItem)) {
      return (
        <Icon
          aria-label={t('table.checkbox_true')}
          className="text-2xl text-primary-500"
          icon="tabler:square-filled"
        />
      );
    }
    return (
      <Icon
        aria-label={t('table.checkbox_false')}
        className="text-2xl text-primary-500"
        icon="tabler:square"
      />
    );
  };

  return (
    <div className="overflow-x-scroll" data-test="table-component">
      <table className="border-none text-left w-full table-auto">
        <thead>
          <tr className="bg-primary-100">
            <th className="border-none font-light p-2" scope="col" />
            {entries.map((entry) => (
              <th
                className="border-none font-light p-2"
                scope="col"
                key={entry.date}
              >
                {entry.dateLabel}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {question.answers.map((answer, i) => {
            if (
              question.type === 'checkbox' &&
              i === question.answers.length - 1
            ) {
              return null;
            }
            const questionItem = answer.chartLabel;
            return (
              <tr className="even:bg-primary-100" key={questionItem}>
                <th className="border-none font-light p-2" scope="row">
                  <span className="font-semibold">{questionItem}</span>
                </th>
                {_.times(entries.length, (entryIndex) => (
                  <td
                    className="border-none p-2"
                    key={`${questionItem}-${entryIndex}`}
                  >
                    {checkboxValue(questionItem, entryIndex)}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
